import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IQueryParams } from "../common/common.types";
import { getSearchQuery } from "../common/helpers";
import { IStoreState } from "../initialStoreState";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { ICompanyOutletAddress } from "./companyOutletAddress.types";

export const FETCH_COMPANY_OUTLET_ADDRESS_LIST_PROGRESS =
	"FETCH_COMPANY_OUTLET_ADDRESS_LIST_PROGRESS";
export const FETCH_COMPANY_OUTLET_ADDRESS_LIST_SUCCESS =
	"FETCH_COMPANY_OUTLET_ADDRESS_LIST_SUCCESS";
export const FETCH_COMPANY_OUTLET_ADDRESS_LIST_FAILED =
	"FETCH_COMPANY_OUTLET_ADDRESS_LIST_FAILED";

export const fetchCompanyOutletAddressListProgress = () =>
	action(FETCH_COMPANY_OUTLET_ADDRESS_LIST_PROGRESS);
export const fetchCompanyOutletAddressListSuccess = (
	data: ICompanyOutletAddress[],
	totalRecords: number
) => action(FETCH_COMPANY_OUTLET_ADDRESS_LIST_SUCCESS, { data, totalRecords });
export const fetchCompanyOutletAddressListFailed = () =>
	action(FETCH_COMPANY_OUTLET_ADDRESS_LIST_FAILED);

export const fetchCompanyOutletAddressListAsync =
	(
		queryParams: IQueryParams,
		customerUUID?: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			const searchQuery = getSearchQuery(queryParams);
			dispatch(fetchCompanyOutletAddressListProgress());
			let finalUrl = `/company/get-company-delivery-address${searchQuery}&company_uuid=${customerUUID}`;
			const res = await api.get(finalUrl);
			const data: ICompanyOutletAddress[] = res.data.data;
			const totalRecords = res.data.totalRecords;
			dispatch(fetchCompanyOutletAddressListSuccess(data, totalRecords));
		} catch (err: any) {
			dispatch(fetchCompanyOutletAddressListFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		}
	};

export const upsertCompanyOutletAddressAsync =
	(
		companyOutletAddress: ICompanyOutletAddress,
		onCallback: (
			isSuccess: boolean,
			companyOutletAddress?: ICompanyOutletAddress
		) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(saveLoaderProgress());
			const { create_ts, insert_ts, rowId, ...rest } = companyOutletAddress;
			const res = await api.post(
				"/company/upsert-company-delivery-address",
				rest
			);
			const data = res.data.data;
			onCallback(true, data);
			dispatch(
				showMessage({
					type: "success",
					message: "Company Outlet Address saved successfully!",
					displayAs: "snackbar",
				})
			);
		} catch (err: any) {
			onCallback(false);
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

export const FETCH_COMPANY_OUTLET_ADDRESS_PROGRESS =
	"FETCH_COMPANY_OUTLET_ADDRESS_PROGRESS";
export const FETCH_COMPANY_OUTLET_ADDRESS_SUCCESS =
	"FETCH_COMPANY_OUTLET_ADDRESS_SUCCESS";
export const FETCH_COMPANY_OUTLET_ADDRESS_FAILED =
	"FETCH_COMPANY_OUTLET_ADDRESS_FAILED";

export const fetchCompanyOutletAddressProgress = () =>
	action(FETCH_COMPANY_OUTLET_ADDRESS_PROGRESS);
export const fetchCompanyOutletAddressSuccess = (data: ICompanyOutletAddress) =>
	action(FETCH_COMPANY_OUTLET_ADDRESS_SUCCESS, { data });
export const fetchCompanyOutletAddressFailed = (errorMessage: string) =>
	action(FETCH_COMPANY_OUTLET_ADDRESS_FAILED, { errorMessage });

export const fetchCompanyOutletAddressAsync =
	(
		companyOutletAddressUUID: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch, getState) => {
		try {
			dispatch(fetchCompanyOutletAddressProgress());
			const res = await api.get(
				`/company/get-company-delivery-address?customer_DELILVERY_ADDRESS_uuid=${companyOutletAddressUUID}`
			);
			const data: ICompanyOutletAddress[] = res.data.data;
			if (data.length > 0) {
				dispatch(fetchCompanyOutletAddressSuccess(data[0]));
			} else {
				dispatch(
					fetchCompanyOutletAddressFailed("Oops! We couldn't find any records.")
				);
			}
		} catch (err: any) {
			dispatch(fetchCompanyOutletAddressFailed("Something went to be wrong!"));
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		}
	};

export const CLEAR_COMPANY_OUTLET_ADDRESS = "CLEAR_COMPANY_OUTLET_ADDRESS";
export const CLEAR_COMPANY_OUTLET_ADDRESS_STATE =
	"CLEAR_COMPANY_OUTLET_ADDRESS_STATE";

export const clearCompanyOutletAddress = () =>
	action(CLEAR_COMPANY_OUTLET_ADDRESS);
export const clearCompanyOutletAddressState = () =>
	action(CLEAR_COMPANY_OUTLET_ADDRESS_STATE);
